import { useTranslation } from 'react-i18next';
import ScrollToTopBadge from '../../component/ScrollToTop';
import LandingpageHeader from '../header/LandingpageHeader';
import Footer from './Footer';
import styles from './footer.module.scss';
import { useEffect } from 'react';

export default function FooterImprint() {
    const { t } = useTranslation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <LandingpageHeader />

            <ScrollToTopBadge />

            <div className="container">
                <article>

                    <h1 className={styles.ueb}>{t('deTranslation.footerImprint.title')}</h1>

                    <h3 className={styles.ueb}>ANBIETERKENNZEICHNUNG NACH § 5 TELEMEDIENGESETZ</h3>

                    <div className={styles.pre1}>
                        ASG Aufmassdienst für den Küchenfachhandel<br />
                        Buchenstraße 16a<br />
                        26689 Apen/Nordloh<br />
                        <br />
                        Arnd-Steffen Glashagen<br />
                        E-Mail: buero@asg-aufmass.de<br />
                        Tel.: 0171 8927809<br />
                        <br />
                        https://web.asg-aufmass.de<br />
                    </div>

                    <h3 className={styles.ueb}>VERTRETUNGSBERECHTIGTE GESCHÄFTSFÜHRER</h3>
                    <div className={styles.pre1}>Arnd-Steffen Glashagen</div>

                    <h3 className={styles.ueb}>HAFTUNGSAUSSCHLUSS NACH § 6TDG:</h3>
                    <div className={styles.pre1}>
                        <span className={styles.spanColor}>ASG Aufmassdienst für den Küchenfachhandel</span> schließt
                        jegliche Haftung für Schäden, die direkt oder indirekt us der Benutzung dieser Website entstehen aus, sofern vonseiten <span className={styles.spanColor}>ASG Aufmassdienst für den
                            Küchenfachhandel</span> kein vorsätzliches oder grob fahrlässiges Verhalten vorliegt.
                    </div>

                    <h3 className={styles.ueb}>COPYRIGHT</h3>
                    <div className={styles.pre1}>ASG Aufmassdienst für den Küchenfachhandel</div>


                    <h3 className={styles.ueb}>VERWEISE UND LINKS</h3>
                    <div className={styles.pre1}>
                        Bei direkten oder indirekten Verweisen auf fremde Webseiten (“Hyperlinks”), die außerhalb des Verantwortungsbereiches von <span className={styles.spanColor}>ASG Aufmassdienst für den Küchenfachhandel</span> liegen, würde eine Haftungsverpflichtung ausschließlich in dem Fall in Kraft treten, in dem <span className={styles.spanColor}>ASG Aufmassdienst für den Küchenfachhandel</span> von den Inhalten Kenntnis hat und es ihm technisch möglich und zumutbar wäre, die Nutzung im Falle
                        rechtswidriger Inhalte zu verhindern. <span className={styles.spanColor}>ASG Aufmassdienst für den Küchenfachhandel</span> erklärt hiermit ausdrücklich, dass zum Zeitpunkt der Linksetzung keine illegalen Inhalte auf den zu verlinkenden Seiten erkennbar waren. Auf die aktuelle und zukünftige Gestaltung, die Inhalte oder die Urheberschaft der verlinkten/verknüpften Seiten hat <span className={styles.spanColor}>ASG Aufmassdienst für den Küchenfachhandel</span> keinerlei Einfluss. Deshalb distanziert sich das Unternehmen hiermit ausdrücklich von allen Inhalten aller verlinkten/verknüpften Seiten,
                        die nach der Linksetzung verändert wurden. Diese Feststellung gilt für alle innerhalb des eigenen Internetangebotes gesetzten Links und Verweise sowie für Fremdeinträge in von ASG Aufmassdienst für den
                        Küchenfachhandel eingerichteten Mailinglisten und in allen anderen Formen von Datenbanken, auf deren
                        Inhalt externe Schreibzugriffe möglich sind. Für illegale, fehlerhafte oder unvollständige Inhalte und insbesondere für Schäden, die aus der Nutzung oder Nichtnutzung solcherart dargebotener Informationen entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen wurde, nicht derjenige, der über Links
                        auf die jeweilige Veröffentlichung lediglich verweist.
                    </div>

                    <h3 className={styles.ueb}>URHEBER- UND KENNZEICHENRECHT</h3>
                    <div className={styles.pre1}>
                        <span className={styles.spanColor}>ASG Aufmassdienst für den Küchenfachhandel</span> ist bestrebt, in allen Publikationen die Urheberrechte der
                        verwendeten Bilder, Grafiken, Tondokumente, Videosequenzen und Texte zu beachten, von ihm selbst erstellte Bilder, Grafiken, Tondokumente, Videosequenzen und Texte zu nutzen oder auf lizenzfreie Grafiken,
                        Tondokumente, Videosequenzen und Texte zurückzugreifen. Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen2
                        Eigentümer. Allein aufgrund der bloßen Nennung ist nicht der Schluss zu ziehen, dass Markenzeichen nicht
                        durch Rechte Dritter geschützt sind. Das Copyright für veröffentlichte, von ASG Aufmassdienst für den Kü-
                        chenfachhandel selbst erstellte Objekte, bleibt allein beim Autor der Seiten. Eine Vervielfältigung oder Verwendung solcher Grafiken, Tondokumente, Videosequenzen und Texte in anderen elektronischen oder gedruckten Publikationen ist ohne ausdrückliche Zustimmung von <span className={styles.spanColor}>ASG Aufmassdienst für den Küchenfachhandel</span> nicht gestattet.
                    </div>

                    <h3 className={styles.ueb}>DATENSCHUTZERKLÄRUNG</h3>
                    <div className={styles.pre1}>
                        Die Verarbeitung personenbezogener Daten, beispielsweise des Namens, der Anschrift, E-Mail-Adresse
                        oder Telefonnummer einer betroffenen Person, erfolgt stets im Einklang mit der Datenschutz-Grundverordnung und in Übereinstimmung mit den für <span className={styles.spanColor}>ASG Aufmassdienst für den Küchenfachhandel</span> geltenden
                        landesspezifischen Datenschutzbestimmungen.
                        Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder eMail-Adressen)
                        erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre
                        ausdrückliche Zustimmung nicht an Dritte weitergegeben. Weitere Informationen zum Datenschutz unter
                        „Datenschutz“.
                    </div>

                    <h3 className={styles.ueb}>KONTAKTMÖGLICHKEIT ÜBER DIE INTERNETSEITE</h3>
                    <div className={styles.pre1}>
                        Die Internetseite von <span className={styles.spanColor}>ASG Aufmassdienst für den Küchenfachhandel</span> enthält aufgrund von gesetzlichen
                        Vorschriften Angaben, die eine schnelle elektronische Kontaktaufnahme zu unserem Unternehmen sowie
                        eine unmittelbare Kommunikation mit uns ermöglichen, was ebenfalls eine allgemeine Adresse der sogenannten elektronischen Post (E-Mail-Adresse) umfasst. Sofern eine betroffene Person per E-Mail oder über
                        ein Kontaktformular, wie dem Chat, den Kontakt mit dem für die Verarbeitung Verantwortlichen aufnimmt,
                        werden die von der betroffenen Person übermittelten personenbezogenen Daten automatisch gespeichert.
                        Solche auf freiwilliger Basis von einer betroffenen Person an den für die Verarbeitung Verantwortlichen
                        übermittelten personenbezogenen Daten werden für Zwecke der Bearbeitung oder der Kontaktaufnahme
                        zur betroffenen Person gespeichert. Es erfolgt keine Weitergabe dieser personenbezogenen Daten an
                        Dritte.
                    </div>

                    <h3 className={styles.ueb}></h3>
                    <div className={styles.pre1}>
                        <strong>Stand: 22.04.2026.</strong>
                    </div>

                    <div className={styles.pre1} style={{ marginTop: '60px' }}>
                        Technische Umsetzung: Mario Bergamotti - <a href="https://www.bergamotti.de" target="_blank" rel="noopener noreferrer">www.bergamotti.de</a>
                    </div>

                </article>

            </div>

            <Footer />
        </>
    );
}
